<template>
	<ImageCardShell
		:data="data"
		:editable="editable"
		:active="active"
		:h5="h5"
		@select="$emit('select')"
	/>
</template>

<script>
	import ImageCardShell from '../shared/ImageCardShell.vue';
	import { imageBlockEmits, imageBlockProps } from '../shared/imageBlockProps.js';

	export default {
		name: 'GBlockImageCard',
		components: { ImageCardShell },
		props: imageBlockProps,
		emits: imageBlockEmits,
	};
</script>
